const SLUG_ID_SEPARATOR = '--'

export const slugify = (value: string): string =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const unslugify = (value: string): string =>
  value.replace(/-/g, ' ').replace(/\b\w/g, char => char.toUpperCase())

export const buildBvaDetailsPath = (id: string, name?: string): string => {
  const slug = name ? slugify(name) : ''
  return `/${slug ? `${slug}${SLUG_ID_SEPARATOR}${id}` : id}`
}

export const parseBvaDetailsParam = (param?: string): { id: string; namePart?: string } => {
  if (!param) return { id: '' }

  const separatorIndex = param.lastIndexOf(SLUG_ID_SEPARATOR)
  if (separatorIndex === -1) return { id: param }

  return { id: param.slice(separatorIndex + SLUG_ID_SEPARATOR.length), namePart: param.slice(0, separatorIndex) }
}
